// @flow
import { onUpdateUserLayers } from 'catena/er2_map_userlayers/js/actions/map'
import { appendToLogger } from 'catena/er2_map_userlayers/js/actions/logger'
import type { UserLayerType } from 'catena/er2_map_userlayers/js/reducers/mapsources'
import * as types from '../constants/action_types'

export const lampsEnd = () => ({ type: types.LAMPS_END })
export const lampsStart = () => ({ type: types.LAMPS_START })

export const runLamps = (layer: UserLayerType) => (dispatch: Function, getState: Function) => {
    let delay = 3000
    let fetchError = false
    const token = getState().token.value

    dispatch(lampsStart())

    const poll = suid => () => {
        fetch(`/er2_map/api/v1/services/lamps/poll/?token=${token}&suid=${suid}`).then((res) => {
            fetchError = !res.ok
            return res.json()
        }).then((json) => {
            if (fetchError) {
                this.props.appendToLogger([json.exception.message, json.exception.traceback])
                dispatch(lampsEnd(json.state))
            } else {
                const { status, first_poll } = json.state.res.metainfo
                if (status === 'Submitted') {
                    // Not finished -- wait and resubmit
                    setTimeout(poll(json.state.res.metainfo.suid), delay)
                } else if (status === 'Running') {
                    if (first_poll) {
                        delay = first_poll
                    }
                    setTimeout(poll(json.state.res.metainfo.suid), delay)
                } else {
                    if (json.state.res.metainfo.error) {
                        this.props.appendToLogger(['LAMPS generated an error:', json.state.res.metainfo.error])
                    }
                    dispatch(lampsEnd(json.state))
                    dispatch(onUpdateUserLayers())
                }
            }
        })
    }

    fetch(`/er2_map/api/v1/services/lamps/?token=${token}`, {
        body: JSON.stringify({
            layer: layer.id,
        }),
        method: 'POST',
    }).then((response) => {
        fetchError = !response.ok
        return response.json()
    }).then((json) => {
        if (fetchError) {
            this.props.appendToLogger([json.exception.message, json.exception.traceback])
        } else {
            fetchError = false
            if (json.state.res.metainfo.status === 'Submitted') {
                // Not finished -- wait and resubmit
                setTimeout(poll(json.state.res.metainfo.suid), delay)
            } else {
                dispatch(lampsEnd(json.state))
            }
        }
    })
}
